import notifyHB from '@/config/notifyHB';
import { http } from '../http';
import { Annotation } from '../pages/upload-document/components/annotation/annotation';

export type NewSigner = {
	order: number;
	email: string;
	role: 'SIGNER';
	components: Omit<Annotation, 'email' | 'id'>[];
};

export async function addDocumentSigners(
	docUlid: string,
	signers: NewSigner[],
) {
	try {
		const response = await http.post<{
			success: boolean;
			errorMessage?: string;
			documentUlid: string;
		}>(`documents/${docUlid}/signers`, { signers });
		return response;
	} catch (exception) {
		notifyHB(
			'use-case',
			'addDocumentSigners',
			`Failed to add document signers with ${exception}`,
		);
		throw exception;
	}
}
